export default function convertLocalToUTC(datetimeLocalString, timezone = '+8') {
    if (!datetimeLocalString) return '';
    
    try {
        // 1. 解析 datetime-local 格式：'YYYY-MM-DDTHH:MM'
        const dateTimeRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
        const match = datetimeLocalString.match(dateTimeRegex);
        
        if (!match) {
        throw new Error('Invalid datetime-local format. Expected: YYYY-MM-DDTHH:MM');
        }
        
        const [, year, month, day, hours, minutes] = match;
        
        // 2. 處理時區偏移
        let timezoneOffset = 0;
        if (typeof timezone === 'string') {
        const timezoneMatch = timezone.match(/^([+-])(\d{1,2})$/);
        if (timezoneMatch) {
            const sign = timezoneMatch[1] === '+' ? 1 : -1;
            const offsetHours = parseInt(timezoneMatch[2]);
            timezoneOffset = sign * offsetHours;
        }
        } else if (typeof timezone === 'number') {
        timezoneOffset = timezone;
        }
        
        // 3. 直接建立 UTC Date 物件，避免本地時區的影響
        // 使用 Date.UTC() 建立真正的 UTC 時間戳
        const utcTimestamp = Date.UTC(
        parseInt(year),
        parseInt(month) - 1, // JavaScript Date 的月份是 0-11
        parseInt(day),
        parseInt(hours) - timezoneOffset, // 直接減去時區偏移
        parseInt(minutes),
        0 // 秒數設為 0
        );
        
        if (isNaN(utcTimestamp)) {
        throw new Error('Invalid date values');
        }
        
        // 4. 建立 UTC Date 物件並返回字串（格式：YYYY/MM/DD hh:mm:ss）
        const utcDate = new Date(utcTimestamp);
        // return utcDate.toISOString();

        const utcYear = utcDate.getUTCFullYear();
        const utcMonth = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
        const utcDay = String(utcDate.getUTCDate()).padStart(2, '0');
        const utcHours = String(utcDate.getUTCHours()).padStart(2, '0');
        const utcMinutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
        const utcSeconds = String(utcDate.getUTCSeconds()).padStart(2, '0');

        return `${utcYear}/${utcMonth}/${utcDay} ${utcHours}:${utcMinutes}:${utcSeconds}`;
        
    } catch (error) {
        console.error('Error converting local time to UTC:', error);
        return '';
    }
};